import IntersectionObsManager from "./IntersectionObserver.js";

class ScrollObserver {
    constructor(elem) {
        this.observerElemsRoot = document.querySelectorAll('[data-observe="root"]');
        this.observerElemsThreshold = document.querySelectorAll('[data-observe="threshold"]');

        this.init();
    }

    handleSectionIntersection = (entry) => {
        if (entry.isIntersecting) {
            entry.target.classList.add("in-view");
        } else {
            if (entry.target.dataset.exit) {
                entry.target.classList.remove("in-view");
            }
        }
    };

    init() {
        this.observerRoot = new IntersectionObsManager({
            rootMargin: "-60% 0% -40% 0%",
        });

        this.observerThreshold = new IntersectionObsManager({
            rootMargin: "0% 0% 0% 0%",
            threshold: 0,
        });

        if (this.observerElemsRoot.length) {
            this.observerElemsRoot.forEach((elem) => {
                this.observerRoot.observe(elem, this.handleSectionIntersection);
            });
        }

        if (this.observerElemsThreshold.length) {
            this.observerElemsThreshold.forEach((elem) => {
                this.observerThreshold.observe(elem, this.handleSectionIntersection);
            });
        }
    }
}

new ScrollObserver();
